export default __webpack_public_path__ + "static/jhamilton-341c76968e02250e7d09fab81caf0e34.jpg";